type ThisSiteIsAvailableInput = {
  url: string
  onUnavailable?: () => void
  onAvailable?: () => void
}

export async function siteIsAvailable({
  url,
  onUnavailable,
  onAvailable,
}: ThisSiteIsAvailableInput): Promise<boolean> {
  try {
    const response = await fetch(url, {method: 'HEAD'})

    if (!response.ok) {
      onUnavailable?.()
      return false
    }

    onAvailable?.()
    return true
  } catch (e) {
    onUnavailable?.()
    return false
  }
}
